<div
  style="
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    background: #000000;
  "
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: var(--iframe-gap);
      align-items: center;
      background: var(--iframe-modal-bg);
      border-radius: 20px;
      padding: 20px;
      max-width: 320px;
      width: calc(100% - 40px);
      max-height: 90vh;
      overflow-y: auto;
    "
  >
    <!-- Icon -->
    <span
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 24px;
        background-color: var(--iframe-button-bg);
        color: var(--iframe-button-text);
        font-size: 14px;
        font-weight: 600;
      "
      >🔑</span
    >

    <!-- Title -->
    <div style="display: flex; align-items: center; gap: var(--iframe-gap); justify-content: center">
      <span
        style="
          width: fit-content;
          font-size: var(--iframe-h1-fz);
          font-weight: var(--iframe-heading-fw);
          line-height: 150%;
          text-align: center;
        "
        >{{title}}</span
      >
    </div>

    <!-- Description -->
    <span
      class="passkey-status"
      style="
        display: block;
        text-align: center;
        font-size: 10px;
        color: var(--iframe-text-secondary);
      "
      >{{description}}</span
    >

    <!-- Action buttons -->
    <div class="passkey-actions" style="display: flex; gap: var(--iframe-gap); width: 100%; align-items: center">
      <button class="cancel-btn">Reject</button>
      <button class="confirm-btn">Confirm</button>
    </div>

    <!-- Footer notice -->
    <span
      style="
        display: block;
        padding: var(--iframe-gap);
        text-align: center;
        font-size: 10px;
        color: var(--iframe-text-secondary);
      "
    >
      Your passkey will be used to securely encrypt the backup.
    </span>
  </div>
</div>